"use strict";

var _useSelectedGlobalSupplierFetchQuery;
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { initPersistedEnvironment } from '@autoguru/relay';
import { useEffect, useState } from 'react';
import { fetchQuery, graphql } from 'react-relay/hooks';
import { useGlobalSupplier } from './GlobalSupplierProvider';
const createResource = promise => {
  let status = 'pending';
  let result = null;
  const suspender = promise.then(data => {
    status = 'success';
    result = data.supplier;
  }, error => {
    status = 'error';
    result = error;
  });
  return {
    read() {
      if (status === 'pending') {
        throw suspender;
      }
      if (status === 'error') {
        throw result;
      }
      return result;
    }
  };
};
export const useSelectedGlobalSupplier = () => {
  const {
    state
  } = useGlobalSupplier();
  const [resource, setResource] = useState(null);
  useEffect(() => {
    if (!(state !== null && state !== void 0 && state.globalSupplierSlug)) {
      return;
    }
    const environment = initPersistedEnvironment();
    const fetchSupplier = fetchQuery(environment, _useSelectedGlobalSupplierFetchQuery !== void 0 ? _useSelectedGlobalSupplierFetchQuery : _useSelectedGlobalSupplierFetchQuery = require("../../relay/__generated__/useSelectedGlobalSupplierFetchQuery.graphql"), {
      slug: state.globalSupplierSlug
    }, {
      fetchPolicy: 'store-or-network'
    }).toPromise();
    setResource(createResource(fetchSupplier));
  }, [state === null || state === void 0 ? void 0 : state.globalSupplierSlug]);
  return (resource === null || resource === void 0 ? void 0 : resource.read()) || {
    id: null,
    dbId: null,
    slug: null,
    name: null
  };
};